export default {"src":"/kaimono/_next/static/media/wamazing_transport_h.a1c31c9d.svg","height":117,"width":513};